import React from "react";
import { twMerge } from "tailwind-merge";
import { Link } from "react-router-dom";
function PrimaryBtn({ to = "", children, className = "", isLoading = false, disabled = false, ...props }) {
  if (to) {
    return (
      <Link
        to={to}
        className={twMerge(
          "flex items-center justify-center 2xl:max-w-[13.021vw] lg:max-w-[250px] max-w-[200px] w-full 2xl:min-h-[2.5vw] min-h-[50px] lg:mb-[1.1vw] md:mb-5 mb-4 2xl:rounded-[0.26vw] rounded-[5px] h-full flex skew-x-[-10deg] 2xl:border-[0.104vw] border-[1.5px] 2xl:text-[1.042vw]/[1.4vw] md:text-lg/tight text-base/tight font-bold text-primary-yellow bg-primary-yellow border-black-300 transition-all duration-200 cursor-pointer text-center 2xl:shadow-[0px_0.156vw_0px_#110706] shadow-[0px_2px_0px_#110706]",
          className
        )}
        {...props}
      >
        <span className="2xl:pt-[0.7vw] md:pt-2.5 pt-3 2xl:m-[0.208vw] m-1 !mt-0 2xl:py-[0.5vw] md:py-2.5 py-3 lg:px-[5%] px-4 2xl:rounded-[0.26vw] rounded-[5px] skew-x-[0deg] !border-t-0 2xl:border-[0.104vw] border-[1.5px] border-black-300 bg-[linear-gradient(180deg,#D76A4D_0%,#B35840_101.89%)] w-full"><span className="skew-x-[10deg] block">
          {" "}
          {children}
        </span></span>
      </Link>
    );
  }

  return (
    <button
      className={twMerge(
        "flex items-center justify-center 2xl:max-w-[13.021vw] lg:max-w-[250px] max-w-[200px] w-full 2xl:min-h-[2.5vw] min-h-[50px]  lg:mb-[1.1vw] md:mb-5 mb-4 2xl:rounded-[0.26vw] rounded-[5px] h-full flex skew-x-[-10deg] 2xl:border-[0.104vw] border-[1.5px] 2xl:text-[1.042vw]/[1.4vw] md:text-lg/tight text-base/tight font-bold text-primary-yellow bg-primary-yellow border-black-300 transition-all duration-200 cursor-pointer text-center 2xl:shadow-[0px_0.156vw_0px_#110706] shadow-[0px_2px_0px_#110706]",
        className
      )}
      disabled={disabled}
      {...props}
    >
      <span className={`2xl:pt-[0.7vw] md:pt-2.5 pt-3 2xl:m-[0.208vw] m-1 !mt-0 2xl:py-[0.5vw] md:py-2.5 py-3 lg:px-[5%] px-4 2xl:rounded-[0.26vw] rounded-[5px] skew-x-[0deg] !border-t-0 2xl:border-[0.104vw] border-[1.5px] border-black-300 bg-[linear-gradient(180deg,#D76A4D_0%,#B35840_101.89%)] w-full ${disabled ? "opacity-80" : ""}`}><span className="skew-x-[10deg] block">
        {isLoading ? (
          <div className="flex items-center justify-center">
            <div className="w-6 h-6 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        ) : (
          children
        )}
      </span></span>
    </button>
  );
}

export default PrimaryBtn;

